import React from 'react';

export function Groovebox() {
    return (
        <div>
            <h1>Groovebox</h1>
            <p>This is a placeholder for the Groovebox component.</p>
            <p>It will be implemented in the future.</p>
        </div>
    );
}